import { useTranslation } from 'react-i18next';

export const BalanceLoader = () => {
  const { t } = useTranslation();

  return (
    <div className="relative mb-0.5 flex h-full min-h-12 w-full flex-col items-center justify-center gap-4 pb-5 sm:mb-0 sm:mt-6 sm:min-h-[4.75rem] sm:pb-8">
      <p className="text-lg font-semibold text-light-grape sm:text-xl">{t('common.waiting')}</p>
    </div>
  );
};
